import React, { useState, useContext, createContext } from "react";
import { MealServices } from "../services/MealServices";
import { useClientCity } from "./useClientCity";

const mealsContext = createContext();

export function ProviderMeals({ children }) {
  const meals = useProviderMeals();
  return (
    <mealsContext.Provider value={meals}>{children}</mealsContext.Provider>
  );
}

export const useMeals = () => {
  return useContext(mealsContext);
};

function useProviderMeals() {
  // ** Hooks
  const { clientCity } = useClientCity();
  // ** State
  // const [mealsItems, setMealsItems] = useState([]);
  const [meals, setMeals] = useState({
    items: [],
    loading: true,
    error: false,
    nextPage: null
  });
  const [mealTypes, setMealTypes] = useState([]);

  const getMealById = (id) => {
    return new Promise((resolve, reject) => {
      MealServices.getWhereID(id)
        .then((result) => {
          const { data } = result;
          if (Object.keys(data?.data).length > 0) {
          // if (Object.keys(data?.data).length > 0) {
            resolve(data?.data);
            // resolve(data?.data);
          } else {
            reject({ message: "Oops Error!" });
          }
        })
        .catch((err) => {
          reject({ message: "Oops Error!" });
        });
    });
  };

  const getMeals = ({ categoryID, cityID }) => {
    setMeals((prev) => ({ ...prev, loading: true }));
    MealServices.getWhereCategoryID({
      categoryID,
      cityID
    })
      .then((res) => {
        const { data } = res;
        if (Array.isArray(data?.data)) {
          setMeals((prev) => ({ ...prev, items: [...data?.data] }));
        }
        if (data?.links) {
          setMeals((prev) => ({ ...prev, nextPage: data?.links?.next }));
        }
      })
      .catch((errors) => {})
      .finally(() => {
        setMeals((prev) => ({ ...prev, loading: false }));
      });
  };

  const mealsGetNextPage = (url) => {
    if (meals.nextPage) {
      MealServices.getWhereCategoryIDPaginate({ url: meals.nextPage })
        .then((res) => {
          const { data } = res;
          if (Array.isArray(data?.data)) {
            setMeals((prev) => ({
              ...prev,
              items: [...prev.items, ...data?.data]
            }));
          }
          setMeals((prev) => ({
            ...prev,
            nextPage: data?.links?.next || null
          }));
        })
        .catch((errors) => {});
    }
  };

  // ** get  meals  by ProviderID
  const getMealsByProviderID = ({ providerID }) => {
    return new Promise((resolve, reject) => {
      MealServices.getMealsByProviderID({ providerID: providerID })
        .then((res) => {
          resolve(res);
        })
        .catch((errors) => {
          reject(errors);
        });
    });
  };

  const getMealsByProviderIDNextPage = ({ url }) => {
    return new Promise((resolve, reject) => {
      MealServices.getNextPage({ url: url })
        .then((res) => {
          resolve(res);
        })
        .catch((errors) => {
          reject(errors);
        });
    });
  };

  // ** Search Meals
  const searchMeals = ({ name, categoryID }) => {
    return new Promise((resolve, reject) => {
      MealServices.searchMeals({
        name: name,
        categoryID: categoryID,
        city_id: clientCity.id
      })
        .then((result) => {
          const { data } = result;
          if (Array.isArray(data?.data)) {
            resolve({
              items: [...data?.data],
              next: data?.links?.next,
              status: true
            });
          } else {
            resolve({ status: true, next: null, items: [] });
          }
        })
        .catch((error) => {
          reject({ status: false, error: error, next: null, items: [] });
        });
    });
  };
  // ** Get Meals By Filter
  const getFilterMeals = ({ filterData,city_id }) => {
    return new Promise((resolve, reject) => {
      MealServices.getFilterMeals({ filter: filterData,city_id })
        .then((result) => {
          const { data } = result;
          if (Array.isArray(data?.data)) {
            resolve({
              items: [...data?.data],
              next: data?.links?.next,
              status: true
            });
          } else {
            resolve({ status: false, next: null });
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  // Return State
  return {
    // mealsItems,
    // setMealsItems,
    meals,
    getMeals,
    getMealById,
    mealsGetNextPage,
    mealTypes,
    setMealTypes,
    getMealsByProviderID,
    getMealsByProviderIDNextPage,
    searchMeals,
    getFilterMeals
  };
}
